module.exports = __webpack_public_path__ + "static/img/illu_de_01.79272fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_de_01.png
// module id = /nuQ
// module chunks = 1